import { FC, useEffect } from 'react'
import {
    useGetReceiptByDocIdQuery,
    useUpdateReceiptMutation,
} from '../../../../../../../../../store/api/receipts-api'
import { Col, DatePicker, Form, Input, Row } from 'antd'
import { useForm } from 'antd/es/form/Form'
import getInitialValues from '../../../../helpers/get-initial-values'
import { EditingFormValues } from '../../types/editing-form-values'
import Supplier from './components/supplier'
import Status from './components/status'
import ReceiptPositionEdit from '../receipt-position-edit/receipt-position-edit'
import useErrorModal from '../../../../../../../../../hooks/api/use-error-modal'
import {
    ConvertRelationFields,
    EndpointQueryParameters,
} from '../../../../../../../../../types/strapi/strapi'
import Receipt from '../../../../../../../../../types/api/receipt'
import _ from 'lodash'
import { outputDateFormat } from '../../../../../../../../../constants/constants'
import dayjs from 'dayjs'

interface EditFormProps {
    documentId: string | undefined
    onSuccess: () => void
}

const EditForm: FC<EditFormProps> = ({ documentId, onSuccess }) => {
    const [form] = useForm<EditingFormValues>()
    const id = documentId ? documentId : ''
    const receiptQueryParams: EndpointQueryParameters = {
        populate: {
            supplier: true,
            receipt_positions: {
                populate: {
                    material: { populate: '*' },
                    initiator: true,
                    unit: true,
                },
            },
        },
    }
    const { data } = useGetReceiptByDocIdQuery([id, receiptQueryParams], {
        skip: !id,
    })
    const [updateReceipt, updateReceiptState] = useUpdateReceiptMutation()

    useErrorModal(updateReceiptState, 'Неудалось обновить поле')

    useEffect(() => {
        if (data) {
            const initialValues = getInitialValues(data?.data)
            form.setFieldsValue(initialValues)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    const onChange = _.debounce(() => {
        save()
    }, 600)

    const save = async () => {
        const value = form.getFieldsValue()
        const initialValues = data?.data
        const updateData: Partial<ConvertRelationFields<Receipt>> = {}

        if (value.supplier && initialValues?.supplier?.documentId !== value.supplier) {
            updateData.supplier = { set: [value.supplier] }
        }
        if (value.receiptStatus && initialValues?.receiptStatus !== value.receiptStatus) {
            updateData.receiptStatus = value.receiptStatus
        }
        if (value.receiptSum && initialValues?.sum !== value.receiptSum) {
            updateData.sum = value.receiptSum
        }
        if (
            value.estimatedDate &&
            initialValues &&
            dayjs(initialValues.estimatedDate) !== value.estimatedDate
        ) {
            updateData.estimatedDate = value.estimatedDate.toISOString()
        }

        if (Object.keys(updateData).length === 0) return

        await updateReceipt({
            docId: id,
            body: {
                data: updateData,
            },
        })
    }

    return (
        <Form form={form} layout={'vertical'}>
            <Row gutter={24}>
                <Col sm={3}>
                    <Form.Item name={'number'} label={'Номер заказа'}>
                        <Input disabled />
                    </Form.Item>
                </Col>
                <Col sm={5}>
                    <Supplier onChange={onChange} />
                </Col>
                <Col sm={4}>
                    <Status onChange={onChange} />
                </Col>
                <Col sm={4}>
                    <Form.Item name={'createdAt'} label={'Дата заказа'}>
                        <Input disabled />
                    </Form.Item>
                </Col>
                <Col sm={4}>
                    <Form.Item name={'estimatedDate'} label={'Дата прихода'}>
                        <DatePicker format={outputDateFormat} onChange={onChange} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col sm={24}>
                    <ReceiptPositionEdit
                        dataSource={data?.data.receipt_positions}
                        receiptId={id}
                        receiptQueryParams={receiptQueryParams}
                    />
                </Col>
            </Row>
        </Form>
    )
}

export default EditForm
